export default () => {
  //add simple support for background images:
  document.addEventListener("lazybeforeunveil", (e) => {
    const backgroundImage = e.target.getAttribute("data-bg"); //check if the element has an background image

    if (backgroundImage) {
      e.target.style.backgroundImage = `url('${backgroundImage}')`; //Unveil the background image. Add style tag to element.
    }
  });
};
